document.addEventListener("DOMContentLoaded", function () {
  const announcementBar = document.querySelector('.announcement-bar-section');
  const sectionHeader = document.querySelector('.section-header');
  const collectionHero = document.querySelector('.collection-hero');

  function getStickyTriggerHeight() {
    let height = 0;
    if (announcementBar) height += announcementBar.offsetHeight;
    if (sectionHeader) height += sectionHeader.offsetHeight;
    if (collectionHero) height += collectionHero.offsetHeight;
    return height;
  }

  let stickyTriggerHeight = getStickyTriggerHeight();

  window.addEventListener('resize', () => {
    stickyTriggerHeight = getStickyTriggerHeight();
  });

  function onScroll() {
    if (window.scrollY > stickyTriggerHeight) {
      document.body.classList.add('pdp-sticky');
    } else {
      document.body.classList.remove('pdp-sticky');
    }
  }

  window.addEventListener('scroll', onScroll);
});
